import React, { useRef, useState, useEffect } from "react";
import "./QuestionsPreview.css";
import plusIcon from "./assets/svg/plus.svg";
import minusIcon from "./assets/svg/minus.svg";
import qnaIcon from "./assets/svg/qna.svg";

const QuestionsPreview = ({ questions = [], onSeeAll }) => {
  return (
    <section className="questions-preview">
      <div className="bg-container">
        <div className="bg-1"></div>
        <div className="bg-2"></div>
      </div>
      <div className="questions-content">
        <h2 className="questions-title">
          <img src={qnaIcon} alt="" className="qna-icon" />
          Kérdések és válaszok
        </h2>
        <div className="questions-scroll">
          {questions.map((q, i) => (
            <QuestionRow key={i} question={q} />
          ))}
        </div>
        <button className="faq-seeall" onClick={onSeeAll}>
          Összes kérdés
        </button>
      </div>
    </section>
  );
};

function QuestionRow({ question }) {
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const contentRef = useRef(null);
  const rowRef = useRef(null);

  useEffect(() => {
    if (open && contentRef.current) {
      // Add padding-bottom to ensure last line is fully visible
      const el = contentRef.current;
      setHeight(el.scrollHeight + 16);
    } else {
      setHeight(0);
    }
  }, [open]);

  const toggle = () => {
    const opening = !open;
    setOpen(opening);
    if (opening) {
      setTimeout(() => {
        if (rowRef.current) {
          rowRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }, 360);
    }
  };

  return (
    <div className="question-row" ref={rowRef}>
      <button className="question-header" onClick={toggle}>
        <span>{question.title}</span>
        <img
          src={open ? minusIcon : plusIcon}
          className="q-icon"
          alt="toggle"
        />
      </button>
      <div
        className="question-body-wrapper"
        style={{ height: `${height}px`, overflow: "hidden", transition: "height 0.35s ease" }}
      >
        <div className="question-body" ref={contentRef}>
          {question.answer}
        </div>
      </div>
    </div>
  );
}

export default QuestionsPreview;